import ResendPasswordLinkPage from "./ResendPasswordLinkPage";

export default ResendPasswordLinkPage;
